import React, { createContext, useState, useContext, useEffect } from "react";
import PropTypes from "prop-types";

const BookingContext = createContext();

const DATE_STORAGE_KEY = "selectedBookingDates";
const TIME_STORAGE_KEY = "trailerPickupTime";

export const BookingProvider = ({ children }) => {
  const [selectedDates, setSelectedDates] = useState(() => {
    const saved = localStorage.getItem(DATE_STORAGE_KEY);
    return saved ? JSON.parse(saved) : { startDate: null, endDate: null };
  });

  const [trailerPickupTime, setTrailerPickupTime] = useState(() => {
    return localStorage.getItem(TIME_STORAGE_KEY) || "16:00";
  });

  useEffect(() => {
    if (selectedDates?.startDate && selectedDates?.endDate) {
      localStorage.setItem(DATE_STORAGE_KEY, JSON.stringify(selectedDates));
    }
  }, [selectedDates]);

  useEffect(() => {
    if (trailerPickupTime) {
      localStorage.setItem(TIME_STORAGE_KEY, trailerPickupTime);
    }
  }, [trailerPickupTime]);

  return (
    <BookingContext.Provider
      value={{
        selectedDates,
        setSelectedDates,
        trailerPickupTime,
        setTrailerPickupTime,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};

BookingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useBooking = () => useContext(BookingContext);
